import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  GithubActionsApiRef,
  GithubActionsClient,
} from '@internal/plugin-neo4j-github-actions';

// Upstream github-actions cards+tab are disabled in app-config.yaml.
// This module provides our custom API; the replacement content tab lives in
// catalogEntityModule.tsx (github-actions).
export const githubActionsModule = createFrontendModule({
  pluginId: 'github-actions',
  extensions: [
    // ── API (→ global API registry) ─────────────────────────
    ApiBlueprint.make({
      name: 'github-actions-api',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: GithubActionsApiRef,
            deps: {
              discoveryApi: discoveryApiRef,
              fetchApi: fetchApiRef,
              identityApi: identityApiRef,
            },
            factory: ({ discoveryApi, fetchApi, identityApi }) =>
              new GithubActionsClient({ discoveryApi, fetchApi, identityApi }),
          }),
        ),
    }),
  ],
});
